import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  SET_DEFAULT_VALUE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    nameOfDeceased: '',
    dateOfInjury: '',
    theClaimIsBeingMadeUnder: '',
    placeWhereAccidentHappened: '',
    describeWhereTheAccidentOccurred: '',
    describeHowTheAccidentOccurred: '',
    checkNameOfDeceased: [],
  },
});

function step16Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case SET_DEFAULT_VALUE: {
      return state.setIn(properties, action.value);
    }
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default step16Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step16/reducer.js